
export const ResizeObserverPolyfill: typeof ResizeObserver = require("resize-observer-polyfill").default;

export default ResizeObserverPolyfill;